<!--
 * @Description: 我的办理
 * @FilePath: /netHallOfficialAccounts/src/views/BusinessManagement/index.vue
-->
<template>
  <div class="businessManagement-page">
    <div class="businessManagement-header">
      <van-tabs
        v-model="businessStatus"
        @click="onClick"
        color="#1677FF"
        title-active-color="#1677FF"
      >
        <!-- <van-tab title="全部" name=""></van-tab> -->
        <van-tab
          v-for="(item, index) in dictoryBycode_STATUS_CODE"
          :key="index"
          :name="item.code"
          :title="item.name"
        ></van-tab>
      </van-tabs>
    </div>
    <!-- <div :class="selectedFlag ? 'businessManagement-select' : 'businessManagement-selected'">
      <van-dropdown-menu active-color="#1677FF" :close-on-click-overlay="false">
        <van-dropdown-item :title="titleValue" ref="item">
          <drop-down-selection
            :currentValue="currentIndex"
            :dataValArr="businessTerms"
            @getSelectValue="getSelectValueInfo"
          />
        </van-dropdown-item>
      </van-dropdown-menu>
    </div> -->

    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      v-if="dataInfoFlag"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="selectFeedbackHandling"
      >

        <div class="businessManagement-content" v-if="dataInfoFlag">
          <ul>
            <li v-for="(item, index) in dataInfo" :key="index" @click="gotoDetailPage(item)">
              <div class="title-li">
                <div class="left-txt">
                  <i
                    ><img
                      :src="item.statusIcon || getStatusIcon(item.orderState)"
                      alt=""
                  /></i>
                  <span>{{ item.orderStateDes || '未知状态' }}</span>
                </div>
                <em>{{ item.createdTime || item.createTime }}</em>
              </div>

              <div class="content-li">
                <span class="van-ellipsis" v-if="item.bizName">{{ item.bizName === '个体报装' ? '用户报装': item.bizName}}</span>
                <span class="van-ellipsis" v-else>业务办理</span>
                <em class="van-ellipsis" v-if="item.processingDays !== undefined">
                  {{ '预计' + item.processingDays + '个工作日' }}
                </em>
              </div>

              <div class="detail-li" @click.stop="gotoDetailPage(item)">
                <span>查看详情</span>
                <van-icon name="arrow" />
              </div>
            </li>
          </ul>
        </div>
      </van-list>
    </van-pull-refresh>

    <no-data v-else />
  </div>
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import NoData from '@/components/noData';
import DropDownSelection from '@/components/dropDownSelection';
import handle_First from '../../assets/icon/ic_blue_icon@2x.png';
import handle_Second from '../../assets/icon/ic_grey_icon@2x.png';
import handle_Third from '../../assets/icon/ic_red_notice_icon@2x.png';
import handle_Fourth from '../../assets/icon/ic_red_refuse@2x.png';
import handle_Fifth from '../../assets/icon/ic_green_icon@2x.png';
import handle_Sixth from '../../assets/icon/待预审@2x.png';
import { formatTime } from '@/utils/tools';
import { detailsRoute, getRouteByBizCode } from '@/utils/businessRoute';
import { selectBusCode, selectFeedbackHandling } from '../../api/user';

export default {
  name: 'BusinessManagement',
  components: {
    NoData,
    // DropDownSelection,
  },
  data() {
    return {
      titleValue: '办理类型筛选',
      businessStatus: '',
      moduleCode: '',
      dataInfo: [],
      dataInfoFlag: true,
      size: 5,
      currentPage: 1,
      dataTotal: 0,
      currentIndex: 0,
      refreshing: false,
      loading: false,
      finished: false,
      selectedFlag: true, // 反馈类型筛选的颜色控制
      dictoryBycode_STATUS_CODE: [
        {
          name: "全部",
          code: "",
        },
        {
          name: "资料审核中",
          code: "PRE_AUDITING",
        },
        {
          name: "办理中",
          code: "PRE_AUDIT_SUCCESS",
        },
        {
          name: "已办结",
          code: "DONE",
        },
        {
          name: "已拒绝",
          code: "REJECTED",
        },
        {
          name: "已取消",
          code: "CANCELED",
        },
      ],
      tabAllList: " ", // 状态码列表
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.query && from.query.businessStatus) {
        vm.businessStatus = from.query.businessStatus == 'all' ? '' : from.query.businessStatus;
        vm.currentIndex = Number(from.query.currentIndex);
        vm.moduleCode = from.query.moduleCode;
        vm.titleValue =
          from.query.isSelected == 'true' ? vm.businessTerms[vm.currentIndex].name : '办理类型筛选';
        vm.selectedFlag = from.query.isSelected == 'true' ? false : true;
      }
    });
  },
  computed: {
    ...mapState('dict', {
      dictory: (state) => state.dictory,
      userInfo: (state) => state.userInfo,
      // dictoryBycode_STATUS_CODE: (state) => state.dictoryBycode_STATUS_CODE,
      businessManagement: (state) => state.businessManagement,
    }),
    businessTerms() {
      if (this.dictory) {
        let data =
          this.dictory &&
          this.dictory[this.businessManagement] &&
          this.dictory[this.businessManagement].child;
        let reomveList = ['0020', '0002', '0003', '0009', '0010', '0011', '0012', '0008', '0005', '0006', '0007', '0013', '0014', '0016'];
        data = data.filter((item) => {
          return !reomveList.includes(item.code);
        });

        let item = [{ child: [], code: '', name: '全部类型', value: '' }];
        let newdata = item.concat(data);
        return newdata;
      }
      return null;
    },
    contentIcon() {
      return function(val, subclass, status) {
        if (val === 'nh_00') {
          /* 办理中 */
          if (status === 'nh_00_01_st') {
            return handle_Sixth;
          } else {
            return handle_First;
          }
        } else if (val === 'nh_01') {
          /* 已办结 */
          return handle_Fifth;
        } else if (val === 'nh_02') {
          /* 已拒绝 */
          return handle_Fourth;
        } else if (val === 'nh_03') {
          /* 已取消 */
          return handle_Second;
        } else if (subclass === 'nh_00_05') {
          /* 补交资料 */
          return handle_Third;
        }
      };
    },
  },
  mounted() {
    // 初始化状态码列表
    if (this.businessStatus === '') {
      this.tabAllList = "";
    } else {
      this.tabAllList = this.businessStatus;
    }
    // this.selectFeedbackHandling()
  },
  methods: {
        // 根据orderState获取状态图标
    getStatusIcon (orderState) {
      if (orderState === 'PRE_AUDITING') {
        // 资料审核中
        return handle_Sixth;
      } else if (orderState === 'PRE_AUDIT_SUCCESS') {
        // 办理中
        return handle_First;
      } else if (orderState === 'DONE') {
        // 已办结
        return handle_Fifth;
      } else if (orderState === 'REJECTED') {
        // 已拒绝
        return handle_Fourth;
      } else if (orderState === 'CANCELED') {
        // 已取消
        return handle_Second;
      } else if (orderState === 'PRE_AUDIT_FAILED') {
        // 待补缴资料
        return handle_Third;
      }
      return handle_First; // 默认图标
    },
    onClick(name, title) {
      this.dataTotal = 0;
      this.currentPage = 1;
      this.dataInfo = [];
      this.finished = false;
      // 根据选中的状态码设置筛选条件
      if (name === '') {
        this.tabAllList = '';
      } else {
        this.tabAllList = name;
      }
      this.selectFeedbackHandling();
    },
    // 选择类型
    getSelectValueInfo(value, index) {
      if (value !== '全部类型') {
        this.businessTerms.map((item) => {
          if (item.name === value) {
            this.moduleCode = item.code;
          }
        });
      } else {
        this.moduleCode = '';
      }
      this.selectedFlag = false;
      this.currentIndex = index;
      this.titleValue = value;
      this.$refs.item.toggle();
      this.currentPage = 1;
      this.dataInfo = [];
      this.selectFeedbackHandling();
    },
    // 获取页面数据
    async selectFeedbackHandling() {
      let arg = {
        userId: store.getters.userInfo.userId,
        orderState: this.tabAllList,
        page: {
          current: this.currentPage,
          size: this.size,
        },
      };
      const { records, total } = await selectFeedbackHandling(arg);
        if (records && records.length > 0) {
          this.dataInfoFlag = true;
          records.map((item) => {
            // 格式化申请时间
            item.createdTime = formatTime(item.createTime);
            // 映射状态图标
            item.statusIcon = this.getStatusIcon(item.orderState);
          });
          // 分页
          this.dataTotal = total;
          this.dataInfo = this.dataInfo.concat(records);
          this.currentPage++;
          // 没有更多数据
          if (this.dataInfo.length >= Number(this.dataTotal)) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.dataInfo = [];
          this.dataInfoFlag = false;
          this.finished = true;
        }
      this.loading = false;
    },
    // 下拉刷新
    onRefresh() {
      this.currentPage = 1;
      this.dataTotal = 0;
      this.dataInfo = [];
      // 重置状态码列表
      if (this.businessStatus === '') {
        this.tabAllList = [];
      } else {
        this.tabAllList = [this.businessStatus];
      }
      this.finished = false;
      this.selectFeedbackHandling();
      this.refreshing = false;
    },
    // 查看详情
    async gotoDetailPage(obj) {
      // 根据bizCode获取路由路径
      let pathDetail = getRouteByBizCode(obj.bizCode);
      if (!pathDetail) {
        // 如果没有找到对应的路由，尝试使用旧的detailsRoute方法
        pathDetail = detailsRoute(obj.businessCode);
      }
      localStorage.setItem("currentFormData", JSON.stringify(obj));
      let data = {
        businessState: 'see',
        businessCode: obj.bizCode,
        moduleCode: obj.moduleCode || '',
        busHandlingId: obj.bizHandleId,
        moduleName: obj.bizName,
      };
      await store.dispatch('user/setBusinessNews', data);
      
      this.$router.push({
        path: pathDetail,
        query: {
          businessStatus: this.businessStatus == '' ? 'all' : this.businessStatus,
          currentIndex: this.currentIndex,
          moduleCode: this.moduleCode,
          isSelected: this.titleValue === '办理类型筛选' ? false : true,
          readonly: true
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.businessManagement-page {
  .businessManagement-select {
    display: flex;
    justify-content: space-between;
    padding: 16px 16px 10px 16px;
    font-size: 14px;
    background: #ffffff;
    /deep/.van-dropdown-menu__title {
      width: 110px;
      color: rgba(0, 0, 0, 0.65);
    }
    /deep/.van-dropdown-menu__bar {
      height: auto;
      background: transparent;
      box-shadow: none;
    }
    /deep/.van-dropdown-menu__title::after {
      border-color: transparent transparent rgba(0, 0, 0, 0.65) rgba(0, 0, 0, 0.65);
    }
    /deep/.van-dropdown-menu__item {
      margin-right: 10px;
    }
  }
  .businessManagement-selected {
    display: flex;
    justify-content: space-between;
    padding: 16px 16px 10px 16px;
    font-size: 14px;
    background: #ffffff;
    /deep/.van-dropdown-menu__bar {
      height: auto;
      background: transparent;
      box-shadow: none;
    }
    /deep/.van-dropdown-menu__title {
      width: 110px;
      color: #1677ff;
    }
    /deep/.van-dropdown-menu__title::after {
      border-color: transparent transparent #1677ff #1677ff;
    }
  }
  .businessManagement-content {
    ul {
      margin-left: 16px;
      margin-right: 16px;
      margin-top: 10px;
      li {
        margin-bottom: 16px;
        background: #ffffff;
        border-radius: 8px;
        padding-left: 16px;
        padding-right: 16px;
        .title-li {
          display: flex;
          justify-content: space-between;
          height: 48px;
          line-height: 48px;
          padding: 0;
          /* border-bottom: 1px solid rgba(0,0,0,0.08); */
          position: relative;
          i {
            font-style: normal;
            padding-right: 8px;
            img {
              width: 18px;
              height: 18px;
              vertical-align: middle;
            }
          }
          span {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            text-align: center;
          }
          em {
            font-style: normal;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            text-align: center;
          }
        }
        .title-li::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 0px;
          bottom: 0;
          left: 0px;
          border-bottom: 1px solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
        .content-li {
          height: 52px;
          line-height: 52px;
          display: flex;
          justify-content: space-between;
          /* border-bottom: 1px solid rgba(0,0,0,0.08); */
          position: relative;
          span {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 700;
            width: 67%;
          }
          em {
            font-style: normal;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            width: 33%;

            i {
              font-style: normal;
            }
          }
          .rightInfo {
            margin-top: 4px;
            p {
              margin: 0px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              text-align: right;
              line-height: 22px;
            }
          }
        }
        .content-li::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 0px;
          bottom: 0;
          left: 0px;
          border-bottom: 1px solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
        .detail-li {
          height: 49px;
          line-height: 49px;
          display: flex;
          justify-content: space-between;
          span {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
          }
          /deep/.van-icon {
            line-height: 49px;
            color: #969799;
          }
        }
      }
    }
  }
}
</style>
